import find from "lodash/find";
import matchesProperty from "lodash/matchesProperty";
export default (node, documentObject) => {
    var _a, _b;
    if (!node || !documentObject || !documentObject.Attributes || !node.AttributeValues)
        return {
            commentsCount: 0,
            likesCount: 0
        };
    const commentsAttr = find(documentObject.Attributes, ["Key", "PT734"]);
    const likesAttr = find(documentObject.Attributes, ["Key", "PT735"]);
    const commentsValue = commentsAttr &&
        ((_a = find(node.AttributeValues, matchesProperty("Key", commentsAttr.Key))) === null || _a === void 0 ? void 0 : _a.Value);
    const commentsCount = parseInt(commentsValue || "0");
    const likesValue = likesAttr &&
        ((_b = find(node.AttributeValues, matchesProperty("Key", likesAttr.Key))) === null || _b === void 0 ? void 0 : _b.Value);
    const likesCount = parseInt(likesValue || "0");
    return {
        commentsCount,
        likesCount
    };
};
